module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2v6oH"))).then(() => module.bundle.root('hEqeo'));